import { useFetchWorkflows } from '@atlassian/jira-business-workflows/src/services/workflows/index.tsx';
import {
	useListViewRefreshCacheActions,
	useListViewRefreshCacheStore,
} from '../list-view-refresh-cache/ListViewRefreshCacheStore.tsx';

export const useRefetchWorkflow = () => {
	const { data: workflows, fetch, refetch, called } = useFetchWorkflows();
	const { resetWorkflowCacheRefreshTrigger } = useListViewRefreshCacheActions();

	const shouldtriggerWorkflowsCacheRefresh = useListViewRefreshCacheStore(
		(state) => state.shouldTriggerWorkflowCacheRefresh,
	);

	if (!called) {
		fetch();
	}

	if (shouldtriggerWorkflowsCacheRefresh) {
		refetch();
		resetWorkflowCacheRefreshTrigger?.();
	}

	return workflows;
};
